import { DropdownOptionWithSubLabel } from '@round/ui-kit';
import { BookingStatus, CampaignStatus, CampaignType, PaymentMethods, PaymentTerms, Platform } from '@round/api';
import { GenericDropdownOption } from './utils.types';

export const PaymentTermsLabels: Record<PaymentTerms, { label: string; description: string }> = {
    accelerated_30: { label: 'Accelerated 3.0%', description: '3.0% processing fee, paid within 7 days' },
    accelerated_45: { label: 'Accelerated 4.5%', description: '4.5% processing fee, paid within 7 days' },
    thirty_days: { label: '30 Days', description: '' },
    client_terms: { label: '60-90 Days', description: '' },
};

export const paymentTermOptions: DropdownOptionWithSubLabel<PaymentTerms>[] = Object.entries(PaymentTermsLabels).map(
    ([key, labels]) => ({
        value: key as PaymentTerms,
        label: labels.label,
        subLabel: labels.description,
    })
);

export const PaymentMethodLabels: Record<PaymentMethods, string> = {
    bank_transfer: 'Bank',
    paypal: 'PayPal',
};

export const preferredPaymentOptions: GenericDropdownOption<PaymentMethods>[] = Object.entries(PaymentMethodLabels).map(
    ([value, label]) => ({
        value: value as PaymentMethods,
        label,
    })
);

export const StatusMap: { [status in BookingStatus]: BookingStatus[] } = {
    offer_sent: ['confirmed', 'declined', 'voided'],
    confirmed: ['draft_approved', 'draft_sent', 'content_only', 'redrafting', 'declined', 'voided'],
    declined: ['confirmed', 'voided'],
    posted: ['voided'],
    draft_approved: ['draft_sent', 'redrafting', 'content_only', 'declined', 'voided'],
    draft_sent: ['draft_approved', 'redrafting', 'content_only', 'declined', 'voided'],
    content_only: ['draft_approved', 'redrafting', 'draft_sent', 'declined', 'voided'],
    redrafting: ['draft_approved', 'draft_sent', 'content_only', 'declined', 'voided'],
    voided: [],
};

export const StatusLabels: { [status in BookingStatus]: string } = {
    offer_sent: 'Offer Sent',
    confirmed: 'Confirmed',
    declined: 'Declined/Cancelled',
    posted: 'Posted',
    draft_approved: 'Draft Approved',
    draft_sent: 'Draft Sent',
    content_only: 'Content Only',
    redrafting: 'Redrafting',
    voided: 'Voided',
};

export const statusOrder: Record<BookingStatus, number> = {
    posted: 1,
    draft_approved: 2,
    draft_sent: 3,
    redrafting: 4,
    confirmed: 5,
    offer_sent: 6,
    content_only: 7,
    declined: 8,
    voided: 9,
};

export const campaignTypeOptions: GenericDropdownOption<CampaignType>[] = [
    {
        label: 'Brand Promotion',
        value: 'BRAND',
    },
    {
        label: 'Audio Promotion',
        value: 'AUDIO',
    },
];

export const COMMUNITY_MANAGER_LABEL = 'Community Manager';

export const communityManagerOption: GenericDropdownOption<null> = {
    value: null,
    label: COMMUNITY_MANAGER_LABEL,
};

export const CampaignStatusLabels: { [status in CampaignStatus]: string } = {
    active: 'Campaign Active',
    completed: 'Campaign Complete',
    awaiting_creator_confirmation: 'Awaiting Creator Confirmation',
};

export const campaignStatusOptions: GenericDropdownOption<CampaignStatus>[] = Object.entries(CampaignStatusLabels).map(
    ([value, label]) => ({
        value: value as CampaignStatus,
        label,
    })
);

export const platformOptions: GenericDropdownOption<Platform>[] = [
    { value: 'INSTAGRAM', label: 'Instagram' },
    { value: 'TIKTOK', label: 'TikTok' },
    { value: 'YOUTUBE', label: 'Shorts (YouTube)' },
];
